import {
    GET_PLAYER_RANDOM_GAME_RECORD,
    USER_OPERATION_LOADING,
    PLAYER_CONFIRM_COMMIT,
    PLAYER_CONFIRM_HUNT_COMMIT,
    SHOW_GAME_TYPE,
    IS_GET_USER_ADDRESS,
    SET_USER_ADDRESS,
    SET_IS_METAMASK_DOWNLOAD,
    GET_PROFIT_RECORD_LIST,
    SET_PLAYER_WATING_STOP_AUTOBET,
    SET_PLAYER_WATING_START_AUTOBET,
    SET_IS_SHOW_ANIMATION,
    USER_SET_LOW_HIGH,
    UPDATE_USEROPERATION_STATUS,
    UPDATE_PLAYER_CLICK_START,
    UPDATE_PLAYER_CLICK_AUTO_START,
    UPDATE_LASTACCOUNT,
    UPDATE_MACHINE_INDEX,
    SET_SHOW_SOURCE_STATUS
} from '../actions/types';

const initialState = {

    /**
     * status
     * 所有跟使用者相關的狀態
     * 0:一般
     * 101:使用者按下"自動投注的按鈕"，等待API回應的狀態
     * 102:手動投注 確認玩家會玩，結算後停止
     * 103:使用者現在就是按開始鈕，必須鎖按鍵
     */
    userOperationStatus:0,


    playerRelatedData: null,
    playerConfirmCommit: '',
    playerConfirmHuntCommit: '',
    loading: false,
    showGameType: null,

    /**
     * 確認使用者端有無顯示address
     * 所有的操作皆須透過此來判斷
     */
    isGetUserAddress:false,
    userAddress:"",
    userID:null, //初始為空

    /**
     * 非使用metamask電腦網頁瀏覽器的判斷
     */
    isNeedToDownloadMetamask:true,

    //分紅列表
    ProfitDividendRecordList:null,


    //玩家是否在等待關閉自動投注
    isPlayerWaitingStopBet:false,
    isPlayerWaitingStartBet:false,


    //是否展示動畫給前端玩家
    isShowingAnimation:false,


    //玩家是否按下開始扭
    isPlayerClickSTART:false,

    //玩家是否按下自動投注開始扭
    isPlayerClickAuto_START:false,

    /**
     * 玩家設定上下限
     * */
    highPercentageCondition:105,
    lowPercentageCondition:95,


    /**
     * 紀錄切換Address
     * */
    lastAccount:"",


    /**
     * 紀錄玩家機台index
     * */
    machineIndex:0,


    /**
     * 使用者是否顯示 Source
     */
    isShowSource:true,

    /**
     * 藍框的index
     */
    afterSelectionRow:0,
};

export default function(state = initialState, action) {
    switch (action.type) {

        case SET_SHOW_SOURCE_STATUS:
            return {
                ...state,
                isShowSource: action.payload
            };


        case UPDATE_MACHINE_INDEX:
            return {
                ...state,
                machineIndex: action.payload
            };

        case UPDATE_LASTACCOUNT:
            return {
                ...state,
                lastAccount: action.payload
            };

        case UPDATE_USEROPERATION_STATUS:
            return {
                ...state,
                userOperationStatus: action.payload
            };

        case UPDATE_PLAYER_CLICK_START:
            return {
                ...state,
                isPlayerClickSTART: action.payload
            };

        case UPDATE_PLAYER_CLICK_AUTO_START:
            return {
                ...state,
                isPlayerClickAuto_START: action.payload
            };


        case USER_SET_LOW_HIGH:
            return {
                ...state,
                highPercentageCondition: action.payload.high,
                lowPercentageCondition: action.payload.low
            };

        //是否有動畫
        case SET_IS_SHOW_ANIMATION:
            return {
                ...state,
                isShowingAnimation: action.payload,
            };

        //等待開始
        case SET_PLAYER_WATING_START_AUTOBET:
            return {
                ...state,
                isPlayerWaitingStartBet: action.payload,
            };

            //等待結束
        case SET_PLAYER_WATING_STOP_AUTOBET:
            return {
                ...state,
                isPlayerWaitingStopBet: action.payload,
            };





        case GET_PROFIT_RECORD_LIST:
            return {
                ...state,
                ProfitDividendRecordList: action.payload,
            };



        case SET_IS_METAMASK_DOWNLOAD:
            return {
                ...state,
                isNeedToDownloadMetamask: action.payload,
            };

        case IS_GET_USER_ADDRESS:
            return {
                ...state,
                isGetUserAddress: action.payload,
            };

        case SHOW_GAME_TYPE:
            return {
                ...state,
                showGameType: action.payload,
            };

        case USER_OPERATION_LOADING:
            return {
                ...state,
                loading: true
            };

        case SET_USER_ADDRESS:
            return {
                ...state,
                userAddress: action.payload
            };

        case GET_PLAYER_RANDOM_GAME_RECORD:
            return {
                ...state,
                playerRelatedData: action.payload,
                loading: false
            };

        case PLAYER_CONFIRM_COMMIT:
            return {
                ...state,
                playerConfirmCommit: action.payload,
                loading: false
            };


        case PLAYER_CONFIRM_HUNT_COMMIT:
            return {
                ...state,
                playerConfirmHuntCommit: action.payload,
                loading: false
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/userOperationReducer.js